import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {
  DonateRequest,
  DonateResponse,
  DonateStatusResponse} from "../interface/donate.interface";

@Injectable({ providedIn: "root" })
export class DonateService {
  constructor(private _httpClient: HttpClient) {}

  donate(request: DonateRequest): Observable<DonateResponse> {
    return this._httpClient.post<any>(
      `${environment.backend}/donations`,
      request
    );
  }

  checkDonate(donateId: string): Observable<DonateStatusResponse> {
    return this._httpClient.get<DonateStatusResponse>(
      `${environment.backend}/donations/${donateId}/check`
    );
  }
}
